import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaProjectList } from '@/service/tuina'

export const fetchTuinaProjectList = createAsyncThunk(
  'tuinaProjectList/fetchTuinaProjectList',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaProjectList(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载服务项目失败'
      )
    }
  }
)

const projectListSlice = createSlice({
  name: 'tuinaProjectList',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaProjectList.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaProjectList.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || {}
      })
      .addCase(fetchTuinaProjectList.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default projectListSlice.reducer
